/* @flow */
import React from "react";
import ReactDOM from "react-dom";
import Root from "./app/Root";
import configureReporting from "../common/configureReporting";
import configureStore from "../common/configureStore";
import config from "../config";
import messages from "../messages/translations";

const initialState = {
  config,
  intl: { messages, currentLocale: "pl", defaultLocale: config.defaultLocale }
};

const reportingMiddleware = configureReporting({
  appVersion: initialState.config.appVersion,
  sentryUrl: initialState.config.sentryUrl,
  unhandledRejection: fn => window.addEventListener("unhandledrejection", fn)
});

const store = configureStore({
  initialState,
  platformDeps: {},
  platformMiddleware: [reportingMiddleware]
});

const appElement = document.getElementById("root");

// Initial render.
ReactDOM.render(<Root store={store} />, appElement);



// WEBPACK FOOTER //
// ./src/browser/main.js